import theme_icons from '../../icons.js';

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { RichText } = wp.blockEditor;
const { TextControl } = wp.components;

const fbgroup = {
    title: 'Facebook Group',
    icon: theme_icons.greenheart,
    category: 'greenheart',
    //attributes
    attributes: {
        title: {
            type: 'string',
            default: 'Sound like your kind of adventure?'
        },
        text: {
            type: 'string',
            default: 'Want access to our Facebook group to talk with travelers on this program?'
        },
        linktext: {
            type: 'string',
            default: 'click here'
        },
        link: {
            type: 'string',
            default: ''
        }

    },

    edit({ attributes, setAttributes }) {
        const { title, text, linktext, link } = attributes;

        function onTextChange(newtext) {
            setAttributes({ text: newtext });
        }
        function onTitleChange(newtitle) {
            setAttributes({ title: newtitle });

        }

        return (
            <div className="rbt-fbgroup">
                <div className="facebook-group layout-row" style={{ display: "flex", gap: "30px" }}>
                    <div className="layout-column" style={{ width: "70%" }}>
                        <RichText
                            tagName="h4"
                            className="block-title"
                            value={title}
                            onChange={onTitleChange}
                            placeholder={'Sound like your kind of adventure?'}
                        />
                        <RichText
                            tagName="p"
                            className="block-text"
                            value={text}
                            onChange={onTextChange}
                            placeholder={'Want access to our Facebook group to talk with travelers on this program?'}
                        />
                    </div>
                    <div className="layout-column" style={{ width: "30%" }}>
                        <TextControl
                            label={'Link Text'}
                            value={linktext}
                            onChange={(newLT) => setAttributes({ linktext: newLT })}
                        />
                        <TextControl
                            label={'Link URL'}
                            value={link}
                            onChange={(newLink) => setAttributes({ link: newLink })}
                        />
                    </div>
                </div>
            </div>
        );
    },
    save({ attributes }) {
        const { title, text, linktext, link } = attributes;

        return (
            <div className="rbt-fbgroup ">
                <div className="facebook-group">
                    <RichText.Content
                        tagName="h3"
                        className="rbt-title"
                        value={title}
                    />
                    <div className="rbt-fbgroup-text">
                        <RichText.Content
                            tagName="span"
                            value={text}
                        />
                        <a href={link} target="_blank" rel="noreferrer noopener" className="rbt-fbgroup-link">{linktext}</a>
                    </div>
                </div>
            </div>
        )
    }
};
registerBlockType('rbt/fbgroup', fbgroup);
export default fbgroup;
